import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import mimeConverter from "mime";
import { Observable, map } from "rxjs";
import { shareReplay } from "rxjs/operators";

export type MimeTypesResult = {
    extensionTypes: Array<string>;
    mimeTypesArr: Array<string>;
    mimeTypesStr: string;
};

@Injectable({
    providedIn: "root"
})
export class AttachmentsService {
    private httpClient = inject(HttpClient);

    private validExtensions$ = this.httpClient.get<Array<string>>(`/api/attachments/extensions`).pipe(shareReplay(1));

    // Signal version for modern reactive patterns
    public fileExtensions = toSignal(this.validExtensions$, { initialValue: [] });

    public getValidExtensions$(): Observable<Array<string>> {
        return this.validExtensions$;
    }

    public getValidMimeTypes$(): Observable<MimeTypesResult> {
        return this.getValidExtensions$().pipe(
            map((extensions = []) => {
                const uniqueExtensions = [...new Set(extensions.filter(Boolean))];
                const mimeTypesArr = uniqueExtensions
                    .map((extension) => mimeConverter.getType(extension.substring(1)))
                    .concat("text/xml")
                    .filter((type): type is string => !!type);

                const uniqueMimeTypes = [...new Set(mimeTypesArr)];

                return {
                    extensionTypes: uniqueExtensions,
                    mimeTypesArr: uniqueMimeTypes,
                    mimeTypesStr: uniqueMimeTypes.join(",")
                };
            })
        );
    }
}
